import { Component, inject, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { AuthService } from '@solcre-org/core';
import {
  BottomNavItem,
  LayoutComponent,
  LogoImagesConfig,
  NavItem,
} from '@solcre-org/core-ui';
import { environment } from '../../../../environments/environment.local';

@Component({
  selector: 'app-app-layout',
  imports: [RouterOutlet, LayoutComponent],
  templateUrl: './app-layout.html',
})
export class AppLayout implements OnInit {
  //Services
  private router: Router = inject(Router);
  private authService: AuthService = inject(AuthService);

  //Models
  public navItems: NavItem[] = [
    { path: '/app/home', label: 'main-nav.home', icon: 'home' },
    {
      path: '/app/maqueta/fleet-ops',
      label: 'main-nav.ships-operations',
      icon: 'update',
      disabled: true,
    },
    {
      path: '/app/voyages',
      label: 'main-nav.voyages',
      icon: 'fa-map',
    },
    {
      path: '/app/bookings',
      label: 'main-nav.bookings',
      icon: 'calendar',
    },
    {
      path: '/app/clients',
      label: 'main-nav.clients',
      icon: 'user',
    },
    {
      path: '/app/ports',
      label: 'main-nav.ports',
      icon: 'fa-anchor',
    },
    { path: '/app/vessels', label: 'main-nav.ships', icon: 'fa-ship' },
    {
      path: '/app/',
      label: 'main-nav.reconciliations',
      icon: 'excel',
      disabled: true,
    },
    {
      path: '/app/audit-log',
      label: 'main-nav.audit-log',
      icon: 'fa-clock-rotate-left',
    },
    {
      label: 'main-nav.configurations',
      icon: 'file',
      children: [
        {
          path: '/app/configuration',
          label: 'main-nav.configuration',
          icon: 'file',
        },
        {
          path: '/app/currency',
          label: 'main-nav.currency',
          icon: 'briefcase',
        },
        {
          path: '/app/country-holidays',
          label: 'main-nav.countryHolidays',
          icon: 'calendar',
        },
        {
          path: '/app/users',
          label: 'main-nav.users',
          icon: 'user',
        },
        {
          path: '/app/change-my-password',
          label: 'main-nav.change-my-password',
          icon: 'user',
        },
      ],
    },
  ];

  bottomNavItems: BottomNavItem[] = [
    {
      id: 'main-nav.home',
      icon: 'icon-home',
      routerLink: '/app/home',
    },
    {
      id: 'main-nav.voyages',
      icon: 'fa-map',
      routerLink: '/app/voyages',
    },
    {
      id: 'main-nav.menu-toggle',
      icon: 'icon-burger',
      isHighlighted: true,
      action: () => { },
    },
    {
      id: 'main-nav.bookings',
      icon: 'calendar',
      routerLink: '/app/bookings',
    },
    {
      id: 'main-nav.clients',
      icon: 'user',
      routerLink: '/app/clients',
    },
  ];

  logoConfig: LogoImagesConfig = {
    collapsedSettings: {
      image: '/assets/images/logo_blanco.svg',
      width: 56,
      height: 56,
      alt: 'KMA - Logo tipo',
    },
    expandedSettings: {
      image: '/assets/images/logo_blanco_expanded.svg',
      width: 0,
      height: 0,
      alt: '',
    },
  };

  ngOnInit(): void {
    this.authService.onSessionStateChange.subscribe(() => {
      // React to change
      const userIsLogged: boolean = this.authService.isLogged();

      if (!userIsLogged) {
        this.router.navigate([environment.STATES.LOGIN]);
      }
    });
  }
}
